import * as React from "react";
import { connect } from "react-redux";
import { HashRouter as Router, Redirect, Route, Switch } from "react-router-dom";

// import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "./stylesheets/theme.css";

import { HomePage, LoginPage } from "./scenes";
import Report from './components/Report';
import IdentityList from './components/identity';
import { IRootState } from './reducers';
import Header from './components/Header';
import LoginHeader from './components/login-header'
import { ResetPasswordPage } from './scenes/reset-password-page';

interface IAppRouterProps {
  isLoggedIn: boolean;
}

const AppRouter: React.StatelessComponent<IAppRouterProps> = (props) => {
  const LoggedUserRoutes = () => (
    <div className="main-page">
      <Header />
      <main className="main-content">
        <Switch>
          <Route exact={true} path="/" component={HomePage} />
          <Route exact={true} path="/identities" component={IdentityList} />
          <Route exact={true} path="/report/page/:page(\d+)/pagesize/:pageSize(\d+)" component={Report} />
          <Redirect to="/" />
        </Switch>
      </main>
    </div>
    )

  const PublicRoutes = () => (
    <main className="main_login">
      <LoginHeader />
      <Switch>
        <Route path="/login" component={LoginPage} />
        <Route path="/password/reset" component={ResetPasswordPage} />
        <Redirect to="/login" />
      </Switch>
    </main>)    

  return (
      <Router>
        {props.isLoggedIn ? <LoggedUserRoutes /> : <PublicRoutes />}
      </Router>
  );
};

const mapStateToProps = (state: IRootState) => ({
  isLoggedIn: state.authState.isLoggedIn
});

export default connect(
  mapStateToProps
)(AppRouter);


// WEBPACK FOOTER //
// ./src/router.tsx